// NEWS SLIDE
let newsSlider = document.querySelectorAll('.swiperNews')
if(newsSlider)
newsSlider.forEach(slide => {
    if(window.innerWidth <= 640) // SMARTHPHONE
        var swiper = new Swiper(slide, {
            slidesPerView: 1,
            spaceBetween: 10,

            autoplay: {
                delay: 5000,
            },
      
            pagination: {
                el: ".section-blog-slider .swiper-pagination",
                clickable:true
            },
            navigation: {
                nextEl: '.section-blog-slider .swiper-button-next',
                prevEl: '.section-blog-slider .swiper-button-prev',
            },
        });
    else // PC
        var swiper = new Swiper(slide, {
            slidesPerView: 2,
            autoplay: {
                delay: 5000,
            },
            spaceBetween: 10,
            pagination: {
                el: '.section-blog-slider .swiper-pagination',
                clickable:true
            },
        });
});

//HOVER EFFECTION OF SUB MENU
document.addEventListener('DOMContentLoaded', () => {
  const allItems = document.querySelectorAll('.product-category-items')
  const menuItems = document.querySelectorAll('.product-category-items.has-sub-menu')
  const isSP = window.matchMedia('(max-width: 768px)').matches

  const closeAllMenus = (exceptItem = null) => {
    menuItems.forEach((item) => {
      if (item !== exceptItem) {
        item.classList.remove('is-open')
      }
    })
  }

   if (isSP) {
    menuItems.forEach((item) => {
      const link = item.querySelector('.category-link')
      const subMenu = item.querySelector('.sub-menu_content')
      if (!link || !subMenu) return
      // 元のリンク情報取得
      const href = link.getAttribute('href')
      const text = link.querySelector('p')?.innerText || link.innerText
      // 親リンク無効化
      link.dataset.href = href
      link.removeAttribute('href')
      // sub-menuに追加
      const li = document.createElement('li')
      li.className = 'sub-menu-link-li'
      const a = document.createElement('a')
      a.className = 'sub-menu-link'
      a.href = href
      a.innerText = text+"全て"
      li.appendChild(a)
      subMenu.prepend(li)
    })
  }
  allItems.forEach((item, index) => {
    const col = (index % 3) + 1
    item.classList.add(`pos-${col}`)
  })

  menuItems.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      if (!isSP) {
        item.classList.add('is-open')
      }
    })

    item.addEventListener('mouseleave', () => {
      if (!isSP) {
        item.classList.remove('is-open')
      }
    })

    item.addEventListener('click', (e) => {
  if (!isSP) return

  const categoryLink = e.target.closest('.category-link')
  if (!categoryLink) return

  e.preventDefault()
  const isOpen = item.classList.contains('is-open')
  closeAllMenus(item)
  item.classList.toggle('is-open', !isOpen)
})
  })
})


// FEATURED PRODUCT SLIDE SMARTPHONE
let productSliders = document.querySelectorAll('.product-slider')
if(productSliders[0])
    productSliders.forEach(slider => {
        
        if(window.innerWidth <= 640) // SMARTHPHONE
        
        var swiper = new Swiper(slider, {
            // centeredSlides:true,
            spaceBetween: 10,
            slidesPerView: 2.2,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: ".product-slider .swiper-pagination",
                clickable:true
            },
            navigation: {
                nextEl: '.product-slider .swiper-button-next',
                prevEl: '.product-slider .swiper-button-prev',
            },
        });
    else // PC
        var swiper = new Swiper(slider, {
            spaceBetween: 15,
            breakpoints: {
              768: {
                slidesPerView: 2.5,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 15,
              },
              1366: {
                slidesPerView: 5.5,
                spaceBetween: 15,
              },
             1920: {
                slidesPerView: 7,
                spaceBetween: 15,
              },
             2560: {
                slidesPerView: 9,
                spaceBetween: 15,
              }
            },
            navigation: {
                nextEl: '.product-slider .swiper-button-next',
                prevEl: '.product-slider .swiper-button-prev',
            },
        
            
            pagination: {
                el: ".product-slider .swiper-pagination",
                clickable:true
            },
    });
});



// HOW TO CHOOSE
let targetMenu = document.querySelectorAll('.target-menu')

targetMenu.forEach( menu => {
    let options = menu.children

    for(let i=0; i < options.length; i++){
        options[i].addEventListener('click', ()=> {
      
            let currentMenu  =  menu.querySelector('.active')
            currentMenu.classList.remove('active')

            let currentDisplay = menu.parentElement.querySelector('.display')
            currentDisplay.classList.remove('display')

            
            options[i].classList.add('active')
            let displayOption = options[i].parentElement.parentElement.querySelector(`[data-option='${options[i].dataset.size}']`)
            
            displayOption.classList.add('display')
            let allLink = options[i].parentElement.parentElement.querySelector('.how-to-choose-more')

            allLink.innerHTML= options[i].dataset.text
            allLink.href= options[i].dataset.href
        })
    }
})





// SLIDER INITIALIZER
//let swiperSliderBanner = new Swiper('.swiper-slider-banner',  sliderSettings );